/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { CpdsTranspoterContainer, CpdsTranspoterText } from './styles/cpds-transpoter-style';
import { CpdsTranspoterProps } from './typings';
import { themeStyleClass } from '../utils/cpds-utils';

const CpdsTranspoter: React.FC<CpdsTranspoterProps> = (props) => {  
  const { 
    domRef, 
    exClasses, 
    styleOverrides, 
    themeTypography, 
    background,
    text = 'Next Story'
  } = props;
  const className = themeStyleClass('cpds-transpoter', themeTypography, exClasses);

  return (
    <CpdsTranspoterContainer 
      className={className} 
      ref={domRef} 
      styleOverrides={styleOverrides}
      background={background}
    >
      <CpdsTranspoterText
        className="cpds-heading-roman-book-06"
      >
        {text}
      </CpdsTranspoterText>
    </CpdsTranspoterContainer>
  );
};

export default CpdsTranspoter;

